/**
 * Frequently Bought Together Styling Handler
 * Handles styling for lazy-loaded frequently bought together sections
 */

const initFrequentlyBoughtTogetherStyling = () => {
  const applyFBTStyling = (container) => {
    if (!container || container.dataset.fbtStyled === 'true') return;

    // Hide if customer is not logged in
    if (!window.customer) {
      container.style.display = 'none';
      container.dataset.fbtStyled = 'true';
      return;
    }

    // Mark as styled to prevent duplicate processing
    container.dataset.fbtStyled = 'true';

    // Find the selector list (checkboxes are in a separate container)
    const selectorList = container.querySelector('.cbb-frequently-bought-selector-list');
    const addButton = container.querySelector('.cbb-frequently-bought-add-button');

    // Move selector list (checkboxes) above the button
    if (selectorList && addButton) {
      addButton.parentNode.insertBefore(selectorList, addButton);
    }

    container.classList.add('processed');
  };

  // Apply to existing containers
  const existingContainers = document.querySelectorAll('.cbb-frequently-bought-container');
  existingContainers.forEach(applyFBTStyling);

  // Set up mutation observer for lazy-loaded content
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is the FBT container
          if (node.classList && node.classList.contains('cbb-frequently-bought-container')) {
            applyFBTStyling(node);
          }

          // Check if the added node contains FBT containers
          const fbtContainers = node.querySelectorAll && node.querySelectorAll('.cbb-frequently-bought-container');
          if (fbtContainers) fbtContainers.forEach(applyFBTStyling);
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Cleanup function
  return () => observer.disconnect();
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFrequentlyBoughtTogetherStyling);
} else {
  initFrequentlyBoughtTogetherStyling();
}

